// <s-product-gallery> pairs a thumbnail rail with a snap-scrolling main viewer.
// Thumbnails are buttons with command="--show" and data-index; scrolling the viewer keeps the active thumbnail in sync.
class ProductGallery extends HTMLElement {
  #abort = null;
  #track = null;
  #thumbs = [];

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.#track = this.querySelector("[data-gallery-track]");
    this.#thumbs = Array.from(this.querySelectorAll("[data-gallery-thumb]"));

    this.addEventListener(
      "command",
      (event) => {
        if (event.command !== "--show") return;
        const index = Number(event.source?.dataset.index ?? 0);
        this.#show(index);
      },
      { signal },
    );

    this.#track?.addEventListener("scrollend", () => this.#sync(), { signal, passive: true });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #show(index) {
    const slide = this.#track?.children[index];
    if (!slide) return;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const width = this.#track.clientWidth;
    const direction = getComputedStyle(this.#track).direction === "rtl" ? -1 : 1;
    this.#track.scrollTo({ left: index * width * direction, behavior: reduceMotion ? "auto" : "smooth" });
    this.#setActive(index);
  }

  #sync() {
    if (!this.#track) return;
    const width = this.#track.clientWidth || 1;
    const index = Math.round(Math.abs(this.#track.scrollLeft) / width);
    this.#setActive(index);
  }

  #setActive(index) {
    this.#thumbs.forEach((thumb, thumbIndex) => {
      if (thumbIndex === index) {
        thumb.setAttribute("aria-current", "true");
      } else {
        thumb.removeAttribute("aria-current");
      }
    });
  }
}

if (!customElements.get("s-product-gallery")) {
  customElements.define("s-product-gallery", ProductGallery);
}
